var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReserve = function SvgReserve(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.83 6.522h1.62v-2h-1.62v2Zm1.62 0A.45.45 0 0 1 15 6.07h2a1.55 1.55 0 0 0-1.55-1.55v2ZM15 6.07v10.38h2V6.07h-2Zm0 10.38c0-.25.2-.451.45-.451v2A1.55 1.55 0 0 0 17 16.45h-2Zm.45-.451H4.55v2h10.9v-2Zm-10.9 0c.25 0 .45.2.45.45H3c0 .855.695 1.55 1.55 1.55v-2Zm.45.45V6.07H3v10.38h2ZM5 6.07a.45.45 0 0 1-.45.452v-2A1.55 1.55 0 0 0 3 6.07h2Zm-.45.452h1.592v-2H4.549v2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.969 5.25a.726.726 0 0 0 .462-.167.67.67 0 0 0 .244-.486c.065-.748.624-1.26 1.26-1.26.61 0 1.195.537 1.26 1.26a.67.67 0 0 0 .244.486c.127.106.29.168.463.168h1.066l.006.005a.02.02 0 0 1 .005.007v1.052a.679.679 0 0 1-.678.678H7.647a.679.679 0 0 1-.679-.678V5.268l.001-.005.005-.007a.021.021 0 0 1 .006-.004.013.013 0 0 1 .006-.001h.983ZM6.96 10.032h6.21m-6.158 3.011h4.91",
    stroke: "currentColor"
  })));
};
export default SvgReserve;